import type { WorldsContent } from "../worldsContent";
import { DE_CREW, DE_CREW_ORDER, DE_WORLD_PAGES } from "./crew";

/**
 * The home-page crew and doors on bidmio.de. Matter-of-fact, not dramatic:
 * door A for those who end the month with nothing left, door B for firms
 * whose paperwork grows faster than they do.
 */
export const DE_WORLDS: WorldsContent = {
  lang: "de",
  crew: DE_CREW,
  order: DE_CREW_ORDER,
  pages: DE_WORLD_PAGES,
  doors: {
    survive: {
      quotes: [
        "Unter Preis angenommen. Die Leasingrate wartet nicht.",
        "Die Löhne krieg ich diesen Monat wieder nicht zusammen.",
        "Geht's auch ohne Rechnung? Schon wieder diese Frage.",
        "Seit zwei Monaten warte ich aufs Geld.",
      ],
      points: [
        "Sie nehmen Aufträge auch unter Preis an, weil Löhne und Leasing nicht warten.",
        "Das Geld ist verdient, nur noch nicht auf dem Konto.",
      ],
    },
    grow: {
      quotes: [
        "Auftragsbuch voll bis Frühjahr. Ich komm nicht hinterher.",
        "Zwei krank, das Dach ist offen.",
        "Wo sind die 40 Meter NYM hin?",
        "Abends noch zwei Stunden Papierkram.",
      ],
      points: [
        "Mit den Leuten kommen Urlaub, Krankmeldungen, Stundenzettel und Meldungen.",
        "Der Umsatz steigt, und trotzdem wissen Sie nicht, welcher Auftrag Geld bringt.",
      ],
    },
  },
  ui: {
    heading: "Wer davon sind Sie?",
    subheading: "Klicken Sie auf den, der Ihnen am nächsten ist, und sehen Sie, wie es weitergeht.",
    lineupAria: "Wählen Sie, wer Ihnen am nächsten ist",
    doorsBadge: "Ganz sachlich",
    doorsTitle: "Wo stehen Sie gerade?",
    doorsIntro:
      "Viele Handwerksbetriebe kommen gerade so über den Monat. Andere haben so viel Arbeit, dass Büro und Papierkram nicht mehr hinterherkommen. Beides ist anstrengend, nur anders.",
    doorLabel: "Tür",
    doorCta: "Das bin ich",
    doorsFooter: "Irgendwo dazwischen? Das geht den meisten so. Sehen Sie sich beide an.",
  },
};
